var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-input",
    _vm._g(
      _vm._b(
        {
          directives: [
            { name: "stopNumberMousewheel", rawName: "v-stopNumberMousewheel" }
          ],
          attrs: { value: _vm.toFormat(_vm.innerValue), type: "number" }
        },
        "el-input",
        _vm.$attrs,
        false
      ),
      _vm.new$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }